/**
 * @module builder
 */
import type { TieredPackagePresetOption } from '../index'

/**
 * Whether a template swaps products.
 *
 * `productSwapsEnabled` is authoritative when set. Templates saved before the field existed have no
 * value, so any saved rule means the section was on — which is what the editor showed them.
 */
export function isProductSwapEnabled(preset?: Pick<TieredPackagePresetOption, 'productSwapsEnabled' | 'productRules'>) {
  if (typeof preset?.productSwapsEnabled === 'boolean') {
    return preset.productSwapsEnabled
  }
  return !!preset?.productRules?.length
}
